import { render, staticRenderFns } from "./fault.vue?vue&type=template&id=a6999d74&scoped=true&"
import script from "./fault.vue?vue&type=script&lang=js&"
export * from "./fault.vue?vue&type=script&lang=js&"
import style0 from "./fault.vue?vue&type=style&index=0&id=a6999d74&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6999d74",
  null
  
)

export default component.exports